// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0_@swc+core@1.7.1_@swc+helpers@0.5.5__/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0_@swc+core@1.7.1_@swc+helpers@0.5.5__/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gZkc0_aXOvvYqOr0P_pb{padding:8px 0}.f2m9aRckqDHgVggwdo6g{margin:20px 0}`, "",{"version":3,"sources":["webpack://./src/domains/SingleActivityView/SingleActivityViewLocation/SingleActivityViewLocation.module.scss"],"names":[],"mappings":"AAAA,sBACE,aAAA,CAGF,sBACE,aAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"locationContainer": `gZkc0_aXOvvYqOr0P_pb`,
	"address": `f2m9aRckqDHgVggwdo6g`
};
export default ___CSS_LOADER_EXPORT___;
